import localForage from "localforage";
import { COLOCATED_SHOWS_STORAGE_KEY } from "../constants";
import { EventEditionDetails } from "../types";

const parseStoredShows = (value: string | null): EventEditionDetails[] => {
  if (!value) {
    return [];
  }

  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? (parsed as EventEditionDetails[]) : [];
  } catch {
    return [];
  }
};

export const getStoredColocatedShows = async (): Promise<EventEditionDetails[]> => {
  const fromLocalStorage = parseStoredShows(localStorage.getItem(COLOCATED_SHOWS_STORAGE_KEY));
  if (fromLocalStorage.length) {
    return fromLocalStorage;
  }

  const fromLocalForage = (await localForage.getItem<EventEditionDetails[]>(COLOCATED_SHOWS_STORAGE_KEY)) || [];

  if (fromLocalForage.length) {
    localStorage.setItem(COLOCATED_SHOWS_STORAGE_KEY, JSON.stringify(fromLocalForage));
  }

  return fromLocalForage;
};

export const saveStoredColocatedShows = async (shows: EventEditionDetails[]) => {
  localStorage.setItem(COLOCATED_SHOWS_STORAGE_KEY, JSON.stringify(shows));
  await localForage.setItem(COLOCATED_SHOWS_STORAGE_KEY, shows);
};

export const getStoredColocatedShowsForEvent = async (
  eventEdition: EventEditionDetails | null | undefined
): Promise<EventEditionDetails[]> => {
  if (!eventEdition) {
    return [];
  }

  try {
    const stored = await getStoredColocatedShows();
    const allowedColocatedIds = new Set((eventEdition.colocatedShows || []).map(show => show.eventEditionId));
    const unique = new Map<string, EventEditionDetails>();

    stored.forEach(show => {
      if (show?.gbsCode && show?.id && allowedColocatedIds.has(show.id)) {
        unique.set(show.id, show);
      }
    });

    return Array.from(unique.values());
  } catch (e) {
    console.warn("[colocated] unable to read stored colocated shows", e);
    return [];
  }
};
